import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrganizationsService } from '../organizations.service';
import { Service } from 'src/app/models/centrex/service';
import { ServiceBase } from '../service-base';

@Injectable({
    providedIn: 'root',
})
export class ServiceService extends ServiceBase {
    constructor(private http: HttpClient, private organizationsServices: OrganizationsService) {
        super();
    }

    getServices(): Observable<Service[]> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Service[]>(`${this.baseUrl}/api/services`, httpOptions);
    }

    getService(serviceName: string): Observable<Service> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Service>(`${this.baseUrl}/api/services/${serviceName}`, httpOptions);
    }

    addService(service: Service, globalNotification = true): Observable<Service> {
        const httpOptions = {
            headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
                .set('global-notification', String(globalNotification))
                .set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.post<Service>(`${this.baseUrl}/api/services`, service, httpOptions);
    }

    updateService(service: Service): Observable<Service> {
        const httpOptions = {
            headers: new HttpHeaders().set('Content-Type', 'application/json').set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.patch<Service>(`${this.baseUrl}/api/services/${service.name}`, service, httpOptions);
    }

    deleteService(serviceName: string) {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.delete<Service>(`${this.baseUrl}/api/services/${serviceName}`, httpOptions);
    }
}
